
    export function fixBase64Mime(dataURL) {
        // Detect true MIME type
        function getMimeFromBase64(dataURL) {
            const base64 = dataURL.includes(",") ? dataURL.split(",")[1] : dataURL;
            const binary = atob(base64.substring(0, 50));
            const bytes = Array.from(binary).map(ch => ch.charCodeAt(0));

            const signatures = [
                { mime: "image/jpeg", sig: [0xFF, 0xD8, 0xFF] },
                { mime: "image/png", sig: [0x89, 0x50, 0x4E, 0x47] },
                { mime: "image/gif", sig: [0x47, 0x49, 0x46, 0x38] },
                { mime: "image/webp", sig: [0x52, 0x49, 0x46, 0x46] },
                { mime: "image/bmp", sig: [0x42, 0x4D] },
                { mime: "image/tiff", sig: [0x49, 0x49, 0x2A, 0x00] },
                { mime: "image/tiff", sig: [0x4D, 0x4D, 0x00, 0x2A] },
            ];

            for (const { mime, sig } of signatures) {
                if (bytes.slice(0, sig.length).every((b, i) => b === sig[i])) {
                    return `data:${mime};base64,${base64}`;
                }
            }
            return dataURL;
        }

        const trueMime = getMimeFromBase64(dataURL);

        // Build new Data URL with correct MIME
        return trueMime;
    }


function _helper() {
   

    function base64ToUint8Array(base64) {
        const binaryString = atob(base64);  // Decode base64 string to binary string
        const byteArray = new Uint8Array(binaryString.length);  // Create a Uint8Array of the same length

        // Fill the Uint8Array with byte values from the binary string
        for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
        }

        return byteArray;
    }
    function base64ToFileUrl(base64, mimeType = 'application/pdf') {
        var ba=base64.split(",")
        if(ba?.length>1){
            console.log(ba)
            ba=ba[1]
        }
        else{
            ba=base64
        }
        // Convert base64 to Uint8Array
        const byteArray = base64ToUint8Array(ba);

        // Create a Blob from the Uint8Array
        const blob = new Blob([byteArray], { type: mimeType });

        // Generate a file URL from the Blob
        const fileUrl = URL.createObjectURL(blob);

        return fileUrl;
    }
    function convertFileToBase64(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    function downloadFile(rawByteData, fileName, mimeType) {
        // Create a Blob from the raw byte data
        const blob = new Blob([rawByteData], { type: mimeType });
    
        // Create an anchor element to trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);  // Create an object URL for the Blob
        link.download = fileName;  // Set the filename for the download
    
        // Programmatically click the link to trigger the download
        link.click();
    
        // Clean up by revoking the object URL
        URL.revokeObjectURL(link.href);
    }

    
        function getMimeFromBase64(dataURL) {
        // Strip the prefix if present
        const base64 = dataURL.includes(",") ? dataURL.split(",")[1] : dataURL;
    
        // Decode small chunk for signature detection
        const binary = atob(base64.substring(0, 50)); // first bytes are enough
        const bytes = Array.from(binary).map(ch => ch.charCodeAt(0));
    
        // Common magic numbers for images
        const signatures = [
            { mime: "img",   sig: [0xFF, 0xD8, 0xFF] },
            { mime: "img",    sig: [0x89, 0x50, 0x4E, 0x47] },
            { mime: "img",    sig: [0x47, 0x49, 0x46, 0x38] },
            { mime: "img",   sig: [0x52, 0x49, 0x46, 0x46] }, // but needs more check
            { mime: "img",    sig: [0x42, 0x4D] },
            { mime: "img",   sig: [0x49, 0x49, 0x2A, 0x00] },
            { mime: "img",   sig: [0x4D, 0x4D, 0x00, 0x2A] },
        ];
    
        for (const { mime, sig } of signatures) {
            if (bytes.slice(0, sig.length).every((b, i) => b === sig[i])) {
                return mime;
            }
        }
    
        return "application/octet-stream"; // fallback
    }

    function checkBase64Type(base64String) {
        // Check if the base64 string has a valid format (it should start with "data:[<mediatype>];base64,")
        const mimeTypePattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-+]+);base64,/;
        const matches = base64String.match(mimeTypePattern);
        if (matches) {
            const mimeType = matches[1]; // Extract the mime type from the base64 string
            
            // Check if it's an image
             if (mimeType.startsWith('data:image/')) {
                return 'img';
            }
            if (mimeType.startsWith('image/')) {
                return 'img';
            }
            
            // Check if it's a PDF
            if (mimeType === 'application/pdf') {
                return 'pdf';
            }
            
            // Otherwise return 'other'
            return getMimeFromBase64(base64String);
        } else {
            return 'Invalid base64 format';
        }
    }
    

    function hasDuplicates(arr) {
        // Filter out null values
        const filteredArr = arr.filter(item => item !== null);
        
        // Check if the filtered array has elements
        if (filteredArr.length === 0) {
            return false; // If filtered array is empty (all values were null), no duplicates
        }
    
        // Convert to Set and compare sizes
        const uniqueArr = new Set(filteredArr);
        return filteredArr.length !== uniqueArr.size; // Return true if there are duplicates, false otherwise
    }
    
    return { hasDuplicates,base64ToUint8Array, base64ToFileUrl, convertFileToBase64,downloadFile,checkBase64Type }
}

export class ApplicationQuery {
    constructor(
        pageIndex = 1,
        pageSize = 10,
        applicationTypeID = "",
        applicationStatusID = "",
        delimitationID = "",
        delimitationLevelID = "",
        channelCategoryID = null,
        passedRequirements = null,
        allowNullDelimitation = false
    ) {
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
        this.applicationTypeID = applicationTypeID;
        this.applicationStatusID = applicationStatusID;
        this.delimitationID = delimitationID;
        this.delimitationLevelID = delimitationLevelID;
        this.channelCategoryID = channelCategoryID;
        this.passedRequirements = passedRequirements;
        this.allowNullDelimitation = allowNullDelimitation;
    }
}


export var helper = _helper()